// toastUtils.js
import { toast } from 'react-toastify';

const toastOptions = {
    position: toast.POSITION.TOP_LEFT,
    style: {
        width: "650px",
        color: "#FFFFFF",
        left: "500px",
        theme: "colored",
    },
};

export const showSaveSuccessMessage = (message) => {
    toast.success(message, {
        ...toastOptions,
        style: {
            ...toastOptions.style,
            backgroundColor: "#49c96d",
        },
    });
};

export const showSaveError = (message) => {
    toast.error(message, {
        ...toastOptions,
        style: {
            ...toastOptions.style,
            backgroundColor: "#eb4335",
        },
    });
};
